import React, {useContext, useEffect} from "react";
import {useTranslation} from "react-i18next";
import "./newAlertsList.scss";
import PopperMenu from "../../shared/popperMenu/popperMenu";
import {AlertModel} from "../../../../alerts/models/alert";
import NewAlertItem from "./newAlertItem/newAlertItem";
import {AlertsService} from "../../../../alerts/services/alertsService";
import {observer} from "mobx-react";
import {storesContext} from "../../../stores/stores";
import {routingAddresses} from "../../../../helpers/routing";
import {RouteComponentProps, withRouter} from "react-router";
import useRefresh from "../../../../helpers/useRefresh";
import Loader from "../../shared/loader/loader";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../models/httpError";
import {Api} from "../../../../helpers/api";
import i18n from "../../../../i18n/i18n";
import Error from "../../shared/error/error";
import {getDefaultApiErrorMessage} from "../../../../helpers/errorMessage";

interface NewAlertListProps extends RouteComponentProps {
    isOpen: boolean;
    setOpen: (isOpen: boolean) => void;
    anchorRef: React.RefObject<HTMLButtonElement>;
}

function NewAlertList(props: NewAlertListProps): JSX.Element {
    const userStore = useContext(storesContext).userStore;
    const {t} = useTranslation();
    const [response, setResponse] = React.useState<AxiosResponse<HttpErrorModel[] | any> | undefined>(undefined);
    const [newAlertList, setNewAlertList] = React.useState<AlertModel[] | undefined>(undefined);
    const alertListRoutingAddress = routingAddresses.alerts.list;
    const refresh = useRefresh(props.history, alertListRoutingAddress);

    useEffect(() => {
        const app = document.querySelector(".app") as HTMLElement;
        let overflow = "";

        if (props.isOpen) {
            setResponse(undefined);
            setNewAlertList(undefined);
            getNewAlertList();
            overflow = "hidden";
        } else {
            overflow = "auto";
        }

        if (app && app.style) {
            app.style.overflow = overflow;
        }
    }, [props.isOpen]);


    return (
        <PopperMenu
            isOpen={props.isOpen}
            setOpen={props.setOpen}
            anchorEl={props.anchorRef.current}
            testId="new-alert-list"
            className="new-alert-list"
            placement="top"
        >
            <div className="content-new-alert-list">
                {renderHeader()}
                {renderContent()}
            </div>
        </PopperMenu>
    );

    function renderContent() {
        if (!Api.isSuccess(response)) {
            return (
                <Error message={getDefaultApiErrorMessage(i18n.t("alerts.retrievalErrorSuffix"))}/>
            );
        } else if (newAlertList !== undefined) {
            return renderNewAlertList();
        } else {
            return <Loader/>;
        }
    }

    function renderHeader(): JSX.Element {
        return (
            <div className="header">{t("alerts.newAlerts.header")}{userStore.unreadAlertsCount}</div>
        );
    }

    function renderNewAlertList(): JSX.Element[] {
        const alertList: JSX.Element[] = [];
        newAlertList!.map((alert) => {
            alertList.push(
                <NewAlertItem
                    date={alert.tags.date}
                    description={alert.description}
                    type={alert.type}
                    onClick={() => {
                        goToAlertList();
                    }}
                    key={alert.id}
                />);
        });

        alertList.push(renderAllAlertsButton());

        return alertList;
    }

    function renderAllAlertsButton() {
        return (
            <div className="all-alerts" onClick={goToAlertList} key="all-alerts">
                {t("alerts.newAlerts.allAlerts")}
            </div>
        );
    }

    function goToAlertList() {
        if (props.history.location.pathname === alertListRoutingAddress) {
            refresh();
        } else {
            props.history.push(alertListRoutingAddress);
        }

        props.setOpen(false);
    }

    function getNewAlertList() {
        AlertsService.getUnreadAlerts().then((response) => {
            setResponse(response);
            setNewAlertList(response?.data?.data || undefined);
        });
    }
}

export default withRouter(observer(NewAlertList));